import React, { useEffect, useRef, useState } from "react"
import { Button, Container, IconButton, LinearProgress, Menu, TextField } from "@mui/material"
import { Chat, Clear, Send } from "@mui/icons-material";
import getBrowserFingerprint from 'get-browser-fingerprint';
import axios from "axios";
import { Fetchconversationsurl, Postmessageurl } from "../utils/chaturls";
import { useSelector } from "react-redux";



const Startmessagemenu = () => {
    const fingerprint = getBrowserFingerprint();
    const webSettings = useSelector((state) => state.webSettings.data);

    const [loading, setloading] = useState(false);
    const [error, seterror] = useState(false);
    const [success, setsuccess] = useState('');
    const [message, setmessage] = useState('');
    const [conversations, setconversations] = useState([]);

    const wrapChatMessagesRef = useRef()

    const fullName = webSettings?.FULL_NAME;
    const firstname = fullName?.split(' ')[0];

    const [anchorEl, setAnchorEl] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        fetchmymessages()
    }, [success]);


    const fetchmymessages = () => {
        seterror()
        setloading(true)
        axios.post(Fetchconversationsurl, {
            clientid: fingerprint
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setconversations(response.data)
                scrollToBottom()
            } else {
                if (response.data.message) {
                    seterror(response.data.message)
                } else {
                    seterror(response.data.error)
                }
            }
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
            //if(error.response.status === 401 || error.response.status === 400){}
        });
    }

    useEffect(() => {
        // Function to be executed every 5 seconds
        const interval = setInterval(() => {
            fetchsilent()
        }, 20000); // 5000 milliseconds = 5 seconds
        // Clean up the interval when the component unmounts
        return () => clearInterval(interval);
    }, []);


    //fetch silent
    const fetchsilent = () => {
        axios.post(Fetchconversationsurl, {
            clientid: fingerprint
        }).then(response => {
            if (!response.data.error) {
                setconversations(response.data)
                scrollToBottom()
            }
        })
    }


    //send messages 
    const sendmessage = () => {
        seterror()
        setloading(true)
        axios.post(Postmessageurl, {
            message: message,
            senderid: fingerprint
        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setmessage('')
                setsuccess(!success)
            } else {
                if (response.data.message) {
                    seterror(response.data.message)
                } else {
                    seterror(response.data.error)
                }
            }
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
            //if(error.response.status === 401 || error.response.status === 400){}
        });
    }



    const Startchat = () => {
        const [name, setname] = useState('');
        const [phone, setphone] = useState('');

        const sendstartmessage = () => {
            seterror()
            setloading(true)
            axios.post(Postmessageurl, {
                message: `Name: ${name} Phone:${phone}`,
                senderid: fingerprint
            }).then(response => {
                setloading(false)
                if (!response.data.error) {
                    setsuccess(true)
                    setTimeout(() => {
                        setsuccess(false)
                    }, 2000);
                } else {
                    if (response.data.message) {
                        seterror(response.data.message)
                    } else {
                        seterror(response.data.error)
                    }
                }
            }).catch(error => {
                setloading(false)
                seterror("Sorry an error occurred,try again later");
                //if(error.response.status === 401 || error.response.status === 400){}
            });
        }

        return (
            <div className="wrapstartupmessage">
                <div className="pleasetext">
                    Please fill out the form below to start chatting with the next available agent.
                </div><br />
                <TextField
                    label="Name"
                    id="outlined-basic"
                    sx={{ marginBottom: 2, width: "100%" }}
                    value={name}
                    autoComplete="name"
                    onKeyDown={(e) => { e.stopPropagation() }}
                    onChange={(e) => setname(e.target.value)}
                    variant="outlined" size="small" />
                <TextField
                    label="Phone"
                    id="outlined-basic"
                    onKeyDown={(e) => { e.stopPropagation() }}
                    sx={{ marginBottom: 2, width: "100%" }}
                    value={phone}
                    type="number"
                    autoComplete="tel"
                    onChange={(e) => setphone(e.target.value)}
                    variant="outlined" size="small" />
                <br />
                <Button disabled={!name && !phone ? true : false} onClick={() => sendstartmessage()} startIcon={<Send />} sx={{ width: "100%" }} variant="contained" >Send</Button>
            </div>
        )
    }

    // Function to scroll to the bottom of the div
    const scrollToBottom = () => {
        if (wrapChatMessagesRef.current) {
            const scrollHeight = wrapChatMessagesRef.current.scrollHeight;
            const height = wrapChatMessagesRef.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            wrapChatMessagesRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
    };

    //conversations
    const Conversations = () => {
        return (
            <div>
                {conversations[0]?.messages?.map((val, key) => {
                    const mine = val.agentid ? false : true
                    return (
                        <div key={key} className={mine ? "chatmine" : "chatsender"}>
                            <div className={mine && "messagetext"}>{val.message}</div>
                        </div>
                    )
                })}
            </div>
        )
    }

    // Function to handle Enter key press
    const handleKeyPress = (e) => {
        e.stopPropagation()
        if (e.key === 'Enter') {
            e.preventDefault();
            sendmessage()
        }
    };




    return (
        <div className="wrapmessagemenu">
            <div className="chatstart" onClick={handleClick}>
                <Chat sx={{ color: "white" }} />
                <div className="startchattext">
                    Chat With Us
                </div>
            </div>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{ sx: { width: '400px', height: '550px' } }}
            >
                <Container maxWidth="md" sx={{ width: "100%" }} >
                    {loading && <LinearProgress />}
                    <div style={{ position: "absolute", right: "5px", top: "5px" }}>
                        <IconButton onClick={() => handleClose()}>
                            <Clear />
                        </IconButton>
                    </div>
                    <div className="chatheader">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="companyname">
                                {fullName}
                            </div>
                            <div className="onlinedot" />
                        </div>
                        <div className="typicallyreplytext">Typically replies in a few minutes</div>
                        <br />
                        {conversations[0]?.agent &&
                            <div>
                                <img src={conversations[0]?.agent.profileurl} className="agentpic" />
                                Chatting with {conversations[0]?.agent?.username}
                            </div>
                        }
                    </div>
                    <div className="wrapchatmessages" ref={wrapChatMessagesRef}>
                        {conversations.length > 0 ? <Conversations /> : <Startchat />}
                    </div>
                    <div className="wrapchatbottom" >
                        {conversations?.length > 0 &&
                            <div className="wrapstartmessagediv">
                                <TextField
                                    id="outlined-basic"
                                    sx={{ marginBottom: 2, width: "80%" }}
                                    value={message}
                                    onKeyDown={handleKeyPress}
                                    onChange={(e) => setmessage(e.target.value)}
                                    variant="outlined"
                                    size="small" />
                                <Button sx={{ marginTop: -2 }} disabled={!message && true} onClick={() => sendmessage()} endIcon={<Send fontSize="25px" color={message && "primary"} />} />
                            </div>
                        }
                        <div className="poweredbydiv">
                            <Chat sx={{ fontSize: 12 }} />&nbsp;  Powered by {firstname}
                        </div>
                    </div>


                </Container>
            </Menu>
        </div>
    )
}

export default Startmessagemenu